export default {
  init() {
    // JavaScript to be fired on all pages
    this.scrollHeader();
    this.phoneMask();
    this.valueChainTab();
    this.productsTab();
    this.detailsTab();
    this.magnificPopup();
    this.formOptionPlaceholder();
    this.callModal();
    this.scroll();
  },

  scrollHeader() {
    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $('.banner').addClass('scrolled');
      } else {
        $('.banner').removeClass('scrolled');
      }
    });

    $('.scrollup').click(function(){
      $('html, body').animate({ scrollTop: 0 }, 600);
      return false;
    });
  },

  phoneMask() {
    //$('input[type="tel"]').mask('+7 (999) 999-9999');
  },

  valueChainTab() {
    let tabItem = '.front-page__value-chain_slider-item';
    let contentItem = '.front-page__value-chain-main-wrapper';

    $(tabItem + ':first-of-type').addClass('item--active')
    $(tabItem + ':not(:first-of-type)').removeClass('item--active')
    /* клик по любому табу */
    $(tabItem).click(function () {
      /* убираем активность с перового таба */
      /*$(tabItem).removeClass('item--active');*/
      /* делаем таб активным */
      $(this).toggleClass('item--active');
      /* первый блок в топку */
      $(contentItem).fadeOut(0);
      /* ищем блок с идентичным свойством data-name для отображения */
      $(contentItem + '[data-name="' + $(this).data('name') + '"]').fadeToggle(100);
      /* проверяем, если нет выбранных табов то выыводим вновь все и делаем первый таб активным */
      if ($('.item--active').length < 1) {
        $(tabItem).addClass('item--active');
      }
    });

    /* клик по первому табу */
    $(tabItem).click(function () {
      $(tabItem).removeClass('item--active');
      $(this).addClass('item--active');
    });
  },

  productsTab() {
    let tabItem = '.front-page__products-list-item';
    let contentItem = '.front-page__products-main-wrapper';

    $(tabItem + ':first-of-type').addClass('item--active')
    $(tabItem + ':not(:first-of-type)').removeClass('item--active')
    /* клик по любому табу */
    $(tabItem).click(function () {
      /* убираем активность с перового таба */
      /*$(tabItem).removeClass('item--active');*/
      /* делаем таб активным */
      $(this).toggleClass('item--active');
      /* первый блок в топку */
      $(contentItem).fadeOut(0);
      /* ищем блок с идентичным свойством data-name для отображения */
      $(contentItem + '[data-name="' + $(this).data('name') + '"]').fadeToggle(100);
      /* проверяем, если нет выбранных табов то выыводим вновь все и делаем первый таб активным */
      if ($('.item--active').length < 1) {
        $(tabItem).addClass('item--active');
      }
    });

    /* клик по первому табу */
    $(tabItem).click(function () {
      $(tabItem).removeClass('item--active');
      $(this).addClass('item--active');
    });
  },

  detailsTab() {
    let tabItem = '.products-page__details_tab-slider-item';
    let contentItem = '.products-page__details-main-wrapper';

    $(tabItem + ':first-of-type').addClass('item--active')
    $(tabItem + ':not(:first-of-type)').removeClass('item--active')
    /* клик по любому табу */
    $(tabItem).click(function () {
      /* убираем активность с перового таба */
      /*$(tabItem).removeClass('item--active');*/
      /* делаем таб активным */
      $(this).toggleClass('item--active');
      /* первый блок в топку */
      $(contentItem).fadeOut(0);
      /* ищем блок с идентичным свойством data-name для отображения */
      $(contentItem + '[data-name="' + $(this).data('name') + '"]').fadeToggle(100);
      /* проверяем, если нет выбранных табов то выыводим вновь все и делаем первый таб активным */
      if ($('.item--active').length < 1) {
        $(tabItem).addClass('item--active');
      }
    });

    /* клик по первому табу */
    $(tabItem).click(function () {
      $(tabItem).removeClass('item--active');
      $(this).addClass('item--active');
    });
  },

  magnificPopup() {
    $('.about-page__rewards-item-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });
  },

  formOptionPlaceholder() {
    $('.wpcf7-select').on('change', function() {
      $(this).css('color', '#000');
    });
    // Topic of the inquiry
    $('.user-menu-01').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-01').children('.wpcf7-select').children('option:contains("---")').html('Topic of the inquiry');

    $('.user-menu-02').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-02').children('.wpcf7-select').children('option:contains("---")').html('Тема запроса');

    $('.user-menu-03').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-03').children('.wpcf7-select').children('option:contains("---")').html('موضوع الاستفسار');
  },

  callModal() {
    $('.button-btn').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper').fadeIn(250);
      $('#wpcf7-f723-o1').fadeIn(250);
      $('#wpcf7-f723-o2').fadeIn(250);
      $('#wpcf7-f723-o3').fadeIn(250);
    });

    $('.modal__wrapper, .modal__block-close-modal').on('click', (e) => {
      if ($(e.target).hasClass('modal__wrapper') || $(e.target).hasClass('modal__block-close-modal')) {
        $('.modal__wrapper').fadeOut(250);
        $('.modal__block > .wpcf7').fadeOut(250);
      }
    });
  },

  scroll() {
    /*
    function smoothScrollToElement(hash, offset = 0, duration = 600) {
      const target = document.querySelector(hash);
      if (!target) return;

      const targetY = window.scrollY + target.getBoundingClientRect().top - offset;

      const startY = window.scrollY;
      const diff = targetY - startY;
      const startTime = performance.now();

      function step(now) {
        const t = Math.min(1, (now - startTime) / duration);
        // easing: easeInOutQuad
        const ease = t < 0.5 ? 2*t*t : -1 + (4 - 2*t)*t;
        window.scrollTo(0, Math.round(startY + diff * ease));
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

// Определяем высоту хедера (если фиксированный)
    function getHeaderHeight() {
      const header = document.querySelector('.banner'); // замени на свой селектор
      return header ? header.getBoundingClientRect().height : 0;
    }

// 1) Плавный переход по клику на якорь
    document.addEventListener('click', function(e) {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;

      const hash = a.getAttribute('href');
      if (!hash || hash.length < 2) return;

      const headerHeight = getHeaderHeight();
      e.preventDefault();
      smoothScrollToElement(hash, headerHeight + 100, 600);
      history.pushState(null, '', hash);
    });

// 2) При открытии страницы сразу с якорем
    window.addEventListener('load', () => {
      if (!location.hash) return;
      const headerHeight = getHeaderHeight();
      setTimeout(() => {
        smoothScrollToElement(location.hash, headerHeight + 100, 600);
      }, 200); // небольшая задержка, чтобы DOM успел отрисоваться
    });
    */
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.navi').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('navi--active');
      $('.banner__nav-primary').toggleClass('banner__nav-primary--active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js